"use client";

import { AppThemeProvider } from "@workspace/ui/components/app-theme-provider";

export const Providers = ({ children }: React.PropsWithChildren) => (
  <AppThemeProvider>{children}</AppThemeProvider>
);
